import { asUserAuthor } from 'domain/shared/author';
import React from 'react';
import { UserProfile } from 'types/user';
import useResourceLegacy from 'util/resource/useResourceLegacy';
import LoadableResource from 'util/resource/Resource';
import useLazyResource from 'util/resource/useLazyResource';

import UpdateForm from './RoomUpdateForm';
import { CreateRoomUpdateDTO, RoomUpdateDTO } from '../types';
import roomUpdateAPI from '../RoomUpdateAPI';
import useNotify from 'hooks/useNotify';

interface OwnProps {
  roomId: string;
  setActive: (v: boolean) => void;
  user?: UserProfile;
  onComplete: (contentId: string, content: RoomUpdateDTO) => void;
  update: RoomUpdateDTO;
}

export default function EditUpdateDialog(props: OwnProps) {
  const { user } = props;
  const author = asUserAuthor(user);
  const notify = useNotify();

  const [attachmentsResource] = useResourceLegacy(
    () =>
      props.update.update.attachments.length > 0
        ? roomUpdateAPI(props.roomId).attachments.list(props.update.update.id)
        : Promise.resolve({ documents: [] }),
    [props.update.update.id, props.roomId],
  );

  const [editUpdate, isSaving] = useLazyResource(
    (dto: CreateRoomUpdateDTO) => roomUpdateAPI(props.roomId).editUpdate(props.update.update.id, dto),
    {
      onSuccess: (result: RoomUpdateDTO) => {
        props.onComplete(props.update.update.id, result);
        props.setActive(false);
        notify('success', 'Post updated!');
      },
      onFailure: () => {
        notify('error', 'Something went wrong when trying to update post');
      },
    },
  );

  return (
    <LoadableResource resource={attachmentsResource}>
      {attachments => (
        <UpdateForm
          dialogTitle="Edit update"
          roomId={props.roomId}
          titleDraft={props.update.update.title}
          contentDraft={props.update.update.content}
          bannerImage={props.update.update.bannerImage}
          attachments={attachments}
          author={author}
          onSave={editUpdate}
          saveButtonText="Save"
          isSaving={isSaving}
          onClose={() => props.setActive(false)}
          contentId={props.update.update.id}
        />
      )}
    </LoadableResource>
  );
}
